module.exports = __webpack_public_path__ + "img/32.7343736e.png";